module.exports = __webpack_public_path__ + "static/plant-2a010505ce3c32807661941ad39767db.png";